/* eslint-disable no-case-declarations */
import { fromJS } from 'immutable';
import * as types from '../constants';
// import { designSettingsDefault } from './state/design';

const getEndTime = () => {
  let date = new Date();
  // eslint-disable-next-line no-restricted-globals
  date = date.setDate(date.getDate() + 2);
  return new Date(date).toISOString();
};

const getIndexField = (state, field, id) => {
  const index = state.getIn(['upsellCampaign', field]).findIndex(item => item === id);
  if (index >= 0) return index;
  return state.getIn(['upsellCampaign', field]).findIndex(() => false);
};

const upsellDefault = {
  id: 0,
  upsellType: 'popup', // 'popup', 'bundle'
  campaignName: '',
  // target
  targetType: 'products', //  'products, 'collection'
  targetProductIds: [],
  targetProductDetail: [],

  targetCollectionIds: [],
  targetCollectionDetail: [],
  // recommend
  recommendType: 'products', //  'products, 'collection'
  recommendProductIds: [],
  recommendProductDetail: [],

  recommendCollectionIds: [],
  recommendCollectionDetail: [],

  // discount

  discountType: 'no',
  discountValue: '0',

  offerMessage: `Hurry up! Add an indispensable choice with {{product_name}}`, // hiện thị khi không setupdiscount
  motivationalMessage: 'Just buy {{quantity}} items to get super promotions below',
  congratulatoryMessage: 'Great! You are eligible to receive a discount below',

  showOnDesktop: true,
  showOnMobile: true,

  startDate: new Date().toISOString(),
  activeEndDate: false,
  endDate: getEndTime(),

  // discount add cart
  dcTargetProducts: [],
  dcTargetCollection: [],

  dcRecommendProducts: [],
  dcRecommendCollection: [],

  listProductsInCollection: []
};

const dataState = fromJS({
  upsellCampaign: upsellDefault,
  listCampaign: [],

  getListCampaignLoading: true,

  getListTargetProductsLoading: false,
  getListTargetCollectionLoading: false,
  getListRecommendPopupCollectionLoading: false,
  getListRecommendPopupProductLoading: false,
  saveSettingLoading: false,
  saveSettingResult: 0,
  changeStatusLoading: false,
  changeStatusResult: 0,
  deleteCampaignLoading: false,
  deleteCampaignResult: 0
});

let indexRemove = 0;
let indexRemoveDetail = 0;
let indexDc = 0;
let indexKey = null;
let data = '';
let isTarget = false;
let isUpsell = false;
let targetIds = [];
let recommendIds = [];
let dcTarget = [];
let dcRecommend = [];
let dcType = 'no';
const offerMessage = `Hurry up! Add an indispensable choice with {{product_name}}`;
const motivationalMessage = `Just buy {{quantity}} items to get super promotions below`;
// const messageSuccess = `Great! You are eligible to receive a discount below`;

const upsellPopupReducer = (state = dataState, action) => {
  switch (action.type) {
    case types.GET_LIST_UPSELL_POPUP:
      return state.set('getListCampaignLoading', true);
    case types.GET_LIST_UPSELL_POPUP_RESULT:
      return state.set('getListCampaignLoading', false).set('listCampaign', fromJS(action.res));
    case types.CHANGE_UPSELL_POPUP_SETTING_FIELD:
      return state.setIn(['upsellCampaign', action.payload.field], action.payload.value);
    case types.CHANGE_UPSELL_POPUP_PRODUCT_DETAIL_FIELD:
      return state.setIn(['upsellCampaign', action.payload.field], action.payload.value);
    case types.CHANGE_UPSELL_POPUP_FIELD:
      return state.set(action.payload.field, action.payload.value);

    // TARGET
    case types.CHANGE_TARGET_PRODUCT_UPSELL_POPUP:
      return state
        .set('getListTargetProductsLoading', true)
        .setIn(['upsellCampaign', 'targetProductIds'], fromJS(action.ids));
    case types.CHANGE_TARGET_PRODUCT_UPSELL_POPUP_RESULT:
      return state
        .set('getListTargetProductsLoading', false)
        .setIn(['upsellCampaign', 'targetProductDetail'], fromJS(action.res));
    case types.CHANGE_LIST_TARGET_POPUP_COLLECTION:
      return state
        .set('getListTargetCollectionLoading', true)
        .setIn(['upsellCampaign', 'targetCollectionIds'], fromJS(action.ids));
    case types.CHANGE_LIST_TARGET_POPUP_COLLECTION_RESULT:
      return state
        .set('getListTargetCollectionLoading', false)
        .setIn(['upsellCampaign', 'targetCollectionDetail'], fromJS(action.res));
    // REMOVE PRODUCT
    case types.REMOVE_TARGET_PRODUCT_UPSELL_POPUP:
      indexRemove = getIndexField(state, 'targetProductIds', action.id);
      indexRemoveDetail = getIndexField(state, 'targetProductDetail', action.id);
      indexDc = getIndexField(state, 'dcTargetProducts', action.id);
      return state
        .removeIn(['upsellCampaign', 'targetProductIds', indexRemove])
        .removeIn(['upsellCampaign', 'targetProductDetail', indexRemoveDetail])
        .removeIn(['upsellCampaign', 'dcTargetProducts', indexDc]);
    case types.REMOVE_TARGET_COLLECTION_UPSELL_POPUP:
      indexRemove = getIndexField(state, 'targetCollectionIds', action.id);
      indexRemoveDetail = getIndexField(state, 'targetCollectionDetail', action.id);
      indexDc = getIndexField(state, 'dcTargetCollection', action.id);
      return state
        .removeIn(['upsellCampaign', 'targetCollectionIds', indexRemove])
        .removeIn(['upsellCampaign', 'targetCollectionDetail', indexRemoveDetail])
        .removeIn(['upsellCampaign', 'dcTargetCollection', indexDc]);

    // UPSELL

    case types.REMOVE_RECOMMEND_PRODUCT_UPSELL_POPUP:
      indexRemove = getIndexField(state, 'recommendProductIds', action.id);
      indexRemoveDetail = getIndexField(state, 'recommendProductDetail', action.id);
      indexDc = getIndexField(state, 'dcRecommendProducts', action.id);
      return state
        .removeIn(['upsellCampaign', 'recommendProductIds', indexRemove])
        .removeIn(['upsellCampaign', 'recommendProductDetail', indexRemoveDetail])
        .removeIn(['upsellCampaign', 'dcRecommendProducts', indexDc]);

    case types.REMOVE_RECOMMEND_COLLECTION_UPSELL_POPUP:
      indexRemove = getIndexField(state, 'recommendCollectionIds', action.id);
      indexRemoveDetail = getIndexField(state, 'recommendCollectionDetail', action.id);
      indexDc = getIndexField(state, 'dcRecommendCollection', action.id);
      return state
        .removeIn(['upsellCampaign', 'recommendCollectionIds', indexRemove])
        .removeIn(['upsellCampaign', 'recommendCollectionDetail', indexRemoveDetail])
        .removeIn(['upsellCampaign', 'dcRecommendCollection', indexDc]);
    case types.CHANGE_LIST_RECOMMEND_POPUP_PRODUCT:
      return state
        .set('getListRecommendPopupProductLoading', true)
        .setIn(['upsellCampaign', 'recommendProductIds'], fromJS(action.ids));
    case types.CHANGE_LIST_RECOMMEND_POPUP_PRODUCT_RESULT:
      return state
        .set('getListRecommendPopupProductLoading', false)
        .setIn(['upsellCampaign', 'recommendProductDetail'], fromJS(action.res));

    case types.CHANGE_LIST_RECOMMEND_POPUP_COLLECTION:
      return state
        .set('getListRecommendPopupCollectionLoading', true)
        .setIn(['upsellCampaign', 'recommendCollectionIds'], fromJS(action.ids));
    case types.CHANGE_LIST_RECOMMEND_POPUP_COLLECTION_RESULT:
      return state
        .set('getListRecommendPopupCollectionLoading', false)
        .setIn(['upsellCampaign', 'recommendCollectionDetail'], fromJS(action.res));

    // DISCOUNT
    case types.CHANGE_DC_UPSELL_POPUP_COMMON:
      indexKey = state
        .getIn(['upsellCampaign', action.payload.param])
        .findIndex(data => data.get('id') === action.payload.item.get('id'));
      return state.setIn(
        ['upsellCampaign', action.payload.param, indexKey, action.payload.field],
        action.payload.value
      );

    case types.CHANGE_DC_TARGET_POPUP_COMMON:
      indexKey = state
        .getIn(['upsellCampaign', action.payload.param])
        .findIndex(data => data.get('id') === action.payload.item.get('id'));
      return state.setIn(['upsellCampaign', action.payload.param, indexKey, 'qty'], action.payload.value);

    // CHANGE STATUS
    case types.CHANGE_STATUS_UPSELL_POPUP:
      return state.set('changeStatusLoading', true);
    case types.CHANGE_STATUS_UPSELL_POPUP_RESULT:
      if (action.res) {
        return state
          .setIn(['listCampaign', action.payload.index, 'status'], action.payload.status)
          .set('changeStatusLoading', false);
      }
      return state.set('changeStatusLoading', false);

    // DELETE CAMPAIGN
    case types.DELETE_CAMPAIGN_UPSELL_POPUP:
      return state.set('deleteCampaignLoading', true);
    case types.DELETE_CAMPAIGN_UPSELL_POPUP_RESULT:
      return state.set('deleteCampaignLoading', false).set('deleteCampaignResult', action.res);

    // SAVE SETTING
    case types.SAVE_SETTING_UPSELL_POPUP_CAMPAIGN:
      return state.set('saveSettingLoading', true);
    case types.SAVE_SETTING_UPSELL_POPUP_CAMPAIGN_RESULT:
      if (action.res) {
        return state
          .setIn(['upsellCampaign', 'id'], action.res)
          .set('saveSettingResult', 1)
          .set('saveSettingLoading', false);
      }
      return state.set('saveSettingLoading', false).set('saveSettingLoading', 2);

    // GET DETAIL
    case types.GET_DETAIL_CAMPAIGN_UPSELL_POPUP:
      if (action.id === 'new') {
        return state.set('upsellCampaign', fromJS(upsellDefault)).set('getDetailUpsellLoading', false);
      }
      return state.set('getDetailUpsellLoading', true);
    case types.GET_DETAIL_CAMPAIGN_UPSELL_POPUP_RESULT:
      if (action.payload.status) {
        data = action.payload.data;

        targetIds = JSON.parse(data.target_ids);
        recommendIds = JSON.parse(data.recommend_ids);
        dcTarget = JSON.parse(data.dc_target);
        dcRecommend = JSON.parse(data.dc_recommend);
        // kiểm tra xem target type có phải 'products'?
        isTarget = data.target_type === 'products';
        isUpsell = data.recommend_type === 'products';

        dcType = data.discount_type;
        return (
          state
            .setIn(['upsellCampaign', 'id'], data.id)
            .setIn(['upsellCampaign', 'upsellType'], data.upsell_type)
            .setIn(['upsellCampaign', 'showProductPage'], data.show_product_page)
            .setIn(['upsellCampaign', 'showCartPage'], data.show_cart_page)
            .setIn(['upsellCampaign', 'campaignName'], data.campaign_name)
            // target
            .setIn(['upsellCampaign', 'targetType'], data.target_type)
            .setIn(['upsellCampaign', 'targetProductIds'], fromJS(isTarget ? targetIds : []))
            .setIn(['upsellCampaign', 'targetCollectionIds'], fromJS(isTarget ? [] : targetIds))
            // upsell
            .setIn(['upsellCampaign', 'recommendType'], data.recommend_type)
            .setIn(['upsellCampaign', 'recommendProductIds'], fromJS(isUpsell ? recommendIds : []))
            .setIn(['upsellCampaign', 'recommendCollectionIds'], fromJS(isUpsell ? [] : recommendIds))
            // discount
            .setIn(['upsellCampaign', 'discountType'], dcType)
            .setIn(['upsellCampaign', 'dcTargetProducts'], fromJS(isTarget ? dcTarget : []))
            .setIn(['upsellCampaign', 'dcTargetCollection'], fromJS(isTarget ? [] : dcTarget))
            .setIn(['upsellCampaign', 'dcRecommendProducts'], fromJS(isUpsell ? dcRecommend : []))
            .setIn(['upsellCampaign', 'dcRecommendCollection'], fromJS(isUpsell ? [] : dcRecommend))
            // message
            .setIn(['upsellCampaign', 'offerMessage'], dcType === 'no' ? data.bundle_message : offerMessage)
            .setIn(
              ['upsellCampaign', 'motivationalMessage'],
              dcType === 'no' ? motivationalMessage : data.bundle_message
            )
            .setIn(['upsellCampaign', 'congratulatoryMessage'], data.bundle_success_message)
            .setIn(['upsellCampaign', 'showOnDesktop'], data.show_on_desktop)
            .setIn(['upsellCampaign', 'showOnMobile'], data.show_on_mobile)
            .setIn(['upsellCampaign', 'startDate'], data.start_date)
            .setIn(['upsellCampaign', 'endDate'], data.end_date)
            .setIn(['upsellCampaign', 'activeEndDate'], data.active_end_date)
            .set('getDetailUpsellLoading', false)
        );
      }
      return state.set('getDetailUpsellLoading', false);
    default:
      return state;
  }
};
export default upsellPopupReducer;
